import { render, staticRenderFns } from "./Flowchart.vue?vue&type=template&id=2b352fca&scoped=true"
import script from "./Flowchart.vue?vue&type=script&lang=js"
export * from "./Flowchart.vue?vue&type=script&lang=js"
import style0 from "./Flowchart.vue?vue&type=style&index=0&id=2b352fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b352fca",
  null
  
)

export default component.exports